import { useMediaQuery } from 'react-responsive'

const useScreen = () => {
    const isMobile = useMediaQuery({ query: `(max-width: 768px)` })
    const isTablet = useMediaQuery({ query: `(max-width: 1280px)` })
    const isSmallScreen = useMediaQuery({ query: `(max-height: 900px)` })

    return {
        isMobile,
        isSmallScreen,
        isTablet,
    }
}

export default useScreen
